import { combineReducers } from "redux";
import {UserModel, userReducer} from "./reducers/user/user.reducer";
import {newsletterReducer} from "./reducers/newsletter/newsletter.reducer";
import {eventsReducer} from "./reducers/events/events.reducer";
import {postReducer} from "./reducers/posts/post.reducer";
import {PostModel} from "../models/post.model";
import {EventModel} from "../models/event.model";
import {NewsletterModel} from "../models/newsletter.model";
import {ContactModel} from "../models/contact.model";
import {contactReducer} from "./reducers/contact/contact.reducer";
import {
    AdvancedFileManagerModel, advancedFileManagerReducer
} from "../components/input/reducers/advanced-file-manager/advanced-file-manager.reducer";

export interface RootReducerState
{
    user: UserModel,
    post: PostModel;
    event: EventModel;
    newsletter: NewsletterModel;
    contact: ContactModel;
    advancedFileManager: AdvancedFileManagerModel;
}

export const rootReducer = combineReducers({
    user: userReducer,
    newsletter: newsletterReducer,
    event: eventsReducer,
    post: postReducer,
    contact: contactReducer,
    advancedFileManager: advancedFileManagerReducer
});